import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Scenarios from "../pages/scenarios/page";
import SeasonEnded from "../pages/season-ended/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SeasonEnded />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/scenarios",
    element: <Scenarios />,
  },
  {
    path: "/season-ended",
    element: <SeasonEnded />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
